import {
    Button,
    Typography
}                      from "@mui/material";
import {
    useEffect,
    useRef
}                      from "react";
import {
    RegisterPoolCommand,
    Pool,
    PoolDetail,
    UpdatePoolCommand,
    AddContactCommand,
    UpdateContactCommand,
    Contact,
    ContactDetail
} from "../constants";
import {useZINContext} from "../context/ZinContextProvider";
import {submitObject}  from "../util";

const ContactForm = () =>
{
    const {
        poolDetails,
        setModalVisible,
        formData,
        setAlertText, setAlertVisible,
        setRefreshResource
    } = useZINContext()
    const FormRef = useRef<any>()

    useEffect(() =>
    {
        if (FormRef.current !== undefined && formData !== undefined)
        {
            FormRef.current.data = {
                ...formData,
            }

        }
    }, []);

    async function HandleSubmit(event: any, refresh : any)
    {

        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status === 200)
        {
            //If everything went okay we can close it
            setModalVisible(false)
            setAlertVisible(false)
            setRefreshResource(refresh)
        }
        else
        {
            let response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }

    }

    function onClickSubmit()
    {
        let Data: any = {}
        // @ts-ignore
        FormRef.current.getData().then((event: any) => Data = event)
        // @ts-ignore
        FormRef.current.submitForm().then(() =>
            {
                if (formData === undefined)
                {
                    submitObject(Data, poolDetails?.id, AddContactCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event,Contact)
                    })
                }
                else
                {
                    submitObject(Data,  poolDetails?.id, UpdateContactCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event,ContactDetail)
                    })
                }
            }
        )
    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            {formData === undefined
             ? "Contact toevoegen"
             : "Contact bewerken"}
        </Typography>

        {formData === undefined
         ?            /*// @ts-ignore*/
         <ig-form lang="nl-NL" ref={FormRef} form-id="AddContact_ZIN"/>
         :            /*// @ts-ignore*/
         <ig-form lang="nl-NL" ref={FormRef} form-id="UpdateContact_ZIN"/>
        }
        <Button className={"od-button"} variant="contained" onClick={onClickSubmit}>Submit</Button>
    </>)
}
export default ContactForm